// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__35mBL","container":"styles_container__2gkwr","title":"styles_title__pGcmP","wrapper":"styles_wrapper__2-5na","answer":"styles_answer__2MHh7"};